import {
  getInstallationList,
  addInstallation,
  getInstallationListById,
  deleteInstallationAPI
} from '../../services/Installation/InstallationService';

export const fetchInstallations = async (payload = {}) => {
  try {
    const response = await getInstallationList(payload);
    if (response && response.success) {
      return response.data || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching installations list',
        variant: 'error'
      });
      console.log('Error fetching installations list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching installations list',
      variant: 'error'
    });
    console.log('Error fetching installations list:', err);
    return [];
  }
};

export const getInstallationById = async (id) => {
  try {
    const response = await getInstallationListById(id);

    if (response && response.success) {
      return response.data;
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching installation details',
        variant: 'error'
      });
      console.log('Error fetching installation details:', response?.message);
      return null;
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching installation details',
      variant: 'error'
    });
    console.log('Error fetching installation details:', err);
    return null;
  }
};

export const saveInstallation = async (
  payload,
  modulesParams,
  customSuccessMsg,
  customErrorMsg
) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      createdGUID: user.userGUID,
      modifiedGUID: user.userGUID,
      createdDate: new Date(),
      modifiedDate: new Date()
    };
    const response = await addInstallation(apiPayload, modulesParams);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save installation');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save installation`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Installation saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to save installation');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save installation:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteInstallation = async (installationGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteInstallationAPI(installationGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete installation');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete installation`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Installation Deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to delete installation');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete installation:', err);
    return { success: false, message: errorMessage };
  }
};
